import React from 'react';
import {PartialNullable} from '../../../../../../../types/types';
import {Contractor} from '../../../../../../api/contractor-api/Contractor';
import {getValidationErrorMessage, ValidationErrorsType} from '../../../../../../utils/utils';
import {ValidateErrorWrapper} from '../../../../../../components/Inputs/ValidateErrorWrapper';
import {InputText} from '../../../../../../components/Inputs/InputText';
import {useIntl} from '../../../../../../hooks/use-intl';

type Props = {
  validationErrors: ValidationErrorsType;
  contractor: PartialNullable<Contractor>;
  updateFields: (props: {[P in keyof Contractor]?: Contractor[P]}) => void;
};

export const LegalFieldsEn: React.FC<Props> = ({validationErrors, updateFields, contractor}) => {
  const intl = useIntl();

  return (
    <>
      <ValidateErrorWrapper message={getValidationErrorMessage<Contractor>('legal_name_en', validationErrors)}>
        <InputText
          value={contractor?.legal_name_en}
          label={intl.formatMessage({id: 'LEGAL_NAME'})}
          hasError={!!getValidationErrorMessage<Contractor>('legal_name_en', validationErrors)}
          onChange={e => updateFields({legal_name_en: e.currentTarget.value})}
          placeholder={intl.formatMessage({id: 'LEGAL_NAME'})}
          classNames={`form-control`}
        />
      </ValidateErrorWrapper>

      <ValidateErrorWrapper message={getValidationErrorMessage<Contractor>('legal_address_en', validationErrors)}>
        <InputText
          value={contractor?.legal_address_en}
          label={intl.formatMessage({id: 'LEGAL_ADDRESS'})}
          hasError={!!getValidationErrorMessage<Contractor>('legal_address_en', validationErrors)}
          onChange={e => updateFields({legal_address_en: e.currentTarget.value})}
          placeholder={intl.formatMessage({id: 'LEGAL_ADDRESS'})}
          classNames={`form-control`}
        />
      </ValidateErrorWrapper>
    </>
  );
};
